import { Grid, InputAdornment, SelectChangeEvent, TextField, Typography } from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { Applicant } from '../../redux-store/types/api-types';
import {
  ckycMaskStartDate,
  grossAnnualMasters,
  grossAnnualValidation,
  investorTypeMasters,
  netWorthValidationDate,
  newGrossAnnualMaster,
  PEPsMasters,
  USER_ROLES,
  whetherRegisterMaster,
  AOI_BOI_MASTER,
  KBOLT_XALT_MASTER,
} from '../../utils/constant';
import { DatePicker } from '../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import {
  applicationComparison,
  checkPmsPoa,
  checkValidationBasedOnDate,
  cleardpIdField,
  currencyConversion,
  dlclIdFieldMandatory,
  getCurrentStep,
  getLastFinancialYearEnd,
  ICEF_I_Fund,
  maxNetworthDate,
  minNetworthDate,
  navigateToNextStep,
  removeSingleQuote,
  saveForLater,
  ifPushToXalt,
  isIndia_Assets_Excellence_Fund1,
} from '../../utils/utilityFunctions';
import { useHistory, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { NonIndividualContributorValidationSchema } from '../../utils/schema';
import { useSnackbar } from 'notistack';
import { DematDetails } from '../investors/additionalKYCDetails';

const contributorObject: Partial<
  Applicant & {
    ckycNoLast4: string | null;
  }
> = {
  name: '',
  cityOfIncorporation: '',
  ckycNo: '',
  ckycNoLast4: '',
  ckycVerified: '',
  kraVerified: '',
  investorType: '',
  detailsOfFamilyCompany: '',
  registeredAs: '',
  registrationNumber: '',
  netWorthDate: '',
  dateOfBirth: '',
  panNo: '',
  grossAnnualIncome: '',
  netWorth: '',
  politicallyExposedPersonStatus: '',
  investmentExperienceInCapitalMarket: '',
  riskProfile: '',
  dlclId: dlclIdFieldMandatory() ? '' : 'none',
  dpId: '',
  clId: '',
  POADP: 'no',
  boiOrAop: '',
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: Partial<
    Applicant & {
      ckycNoLast4: string | null;
    }
  >[];
  schemeId: string;
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
  schemeId: '',
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    try {
      const { applicants = [] } = application || {};
      setContributorValues({
        ...contributorValues,
        applicants: applicants.length
          ? applicants.map((applicant) => {
              return {
                ...applicant,
                dlclId: applicant.dlclId ? applicant.dlclId : dlclIdFieldMandatory() ? '' : 'none',
                POADP: applicant.POADP ? applicant.POADP : 'no',
                ckycNoLast4: applicant.ckycNo
                  ? checkValidationBasedOnDate(application?.createdAt, ckycMaskStartDate)
                    ? applicant.ckycNo.slice(-4)
                    : applicant.ckycNo
                  : '',
                boiOrAop: applicant.boiOrAop || '',
              };
            })
          : [contributorObject],
        schemeId: application?.schemeId || '',
      });
    } catch (e) {
      console.error((e as Error).message);
    }
  }, [application]);

  const handleApplicant = async (values: Values) => {
    const { saveType, applicants = [] } = values;
    const { id, currentStep, banks = [] } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();
    const isSaveLater = saveType !== 'save and proceed';
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: values.applicants
          .map((applicant) => {
            const { ckycNoLast4, ...restApplicant } = applicant;
            return {
              ...restApplicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              clId: cleardpIdField(applicant.dlclId || '') ? '' : applicant.clId,
              dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant.dpId,
              ckycNo: checkValidationBasedOnDate(application?.createdAt, ckycMaskStartDate)
                ? ckycNoLast4
                  ? `XXXXXXXXXX${ckycNoLast4}`
                  : ''
                : applicant.ckycNo,
            };
          })
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        currentStep:
          !!currentStep &&
          currentStep > getCurrentStep(application?.applicationType || '', path, isSaveLater) - 1
            ? currentStep
            : !checkPmsPoa(values.applicants)
            ? getCurrentStep(application?.applicationType || '', path, isSaveLater) - 1
            : getCurrentStep(application?.applicationType || '', path, isSaveLater),
      }
    );

    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: values.applicants.map((applicant, index) => {
              const { ckycNoLast4, ...restApplicant } = applicant;
              return {
                ...restApplicant,
                name: removeSingleQuote(applicant.name),
                cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
                clId: cleardpIdField(applicant.dlclId || '') ? '' : applicant.clId,
                dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant.dpId,
                ckycNo: checkValidationBasedOnDate(application?.createdAt, ckycMaskStartDate)
                  ? ckycNoLast4
                    ? `XXXXXXXXXX${ckycNoLast4}`
                    : ''
                  : applicant.ckycNo,
                boiOrAop:
                  ifPushToXalt(application?.pushDataTo || '') &&
                  investorTypeMasters[applicants[index]?.investorType || ''] ===
                    investorTypeMasters.boi_or_aop
                    ? applicants[index].boiOrAop
                    : '',
              };
            }),
            modeOfHolding: 'single',
            currentStep: !checkPmsPoa(values.applicants)
              ? getCurrentStep(application?.applicationType || '', path, isSaveLater) - 1
              : getCurrentStep(application?.applicationType || '', path, isSaveLater),
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );
    } else if (checkApplication) {
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(
          `Application ${application?.applicationNumber} - ` + ' Saved successfully',
          {
            variant: 'success',
            autoHideDuration: 3000,
          }
        );
      }
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      const { id, applicant1ReferenceId = '', applicationNumber } = application || {};
      const { saveType } = values;
      const isSaveLater = saveType !== 'save and proceed';
      await handleApplicant(values);
      history.push(
        navigateToNextStep(
          path,
          role,
          id || '',
          isSaveLater,
          applicant1ReferenceId || '',
          application?.applicationType || ''
        ),
        { id, applicant1ReferenceId }
      );
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            NonIndividualContributorValidationSchema(
              application?.createdAt || '',
              Number(application?.scheme?.nonIndMinNetworth),
              ifPushToXalt(application?.pushDataTo || '')
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, setFieldValue }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            //columnSpacing={5}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.name`}
                    label="Name of Entity *"
                    placeholder="Enter Name of Entity"
                    disabled={applicant.dataFetchedFromKRA || applicant.isCMLFetched || false}
                  />
                </Grid>
                {console.log(values, 'checkvalues')}
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Date of Registration/Incorporation *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'DD/MM/YYYY'}
                    name={`applicants.${index}.dateOfBirth`}
                    disabled={applicant.dataFetchedFromKRA || applicant.isCMLFetched || false}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cityOfIncorporation`}
                    label="Place of Registration/Incorporation *"
                    placeholder="Enter Place of Registration/Incorporation"
                  />
                </Grid>
                {checkValidationBasedOnDate(application?.createdAt, ckycMaskStartDate) ? (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.ckycNoLast4`} // only store last 4 digits
                      label="CKYC No./CKYC Acknowledge No./KIN No"
                      placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                      inputProps={{ maxLength: 4 }}
                      startAdornment={
                        <InputAdornment position="start">
                          <TextField
                            value="XXXXXXXXXX"
                            disabled
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline': { border: 0 },
                              '& .MuiInputBase-input': {
                                padding: '10px 8px 10px 4px', // nicely aligned with MFTextField
                                width: '95px',
                                textAlign: 'right',
                              },
                              background: 'transparent',
                            }}
                          />
                        </InputAdornment>
                      }
                      disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.ckycNo`}
                      label="CKYC No./CKYC Acknowledge No./KIN No"
                      placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.investorType`}
                    label="Investor Type *"
                    items={Object.keys(investorTypeMasters).map((investor) => ({
                      key: investorTypeMasters[investor],
                      value: investor,
                    }))}
                  />
                </Grid>
                {/* {ifPushToXalt(application?.pushDataTo || '') &&
                  investorTypeMasters[values?.applicants[index]?.investorType || ''] ===
                    investorTypeMasters.boi_or_aop && (
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.boiOrAop`}
                        label="AOP or BOI *"
                        items={Object.keys(AOI_BOI_MASTER).map((investor) => ({
                          key: AOI_BOI_MASTER[investor],
                          value: investor,
                        }))}
                      />
                    </Grid>
                  )} */}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.panNo`}
                    label="PAN *"
                    placeholder="Enter PAN"
                    disabled={true}
                  />
                </Grid>
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Other Details
                </SubHeading>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.grossAnnualIncome`}
                    label="Gross Annual Income *"
                    items={(checkValidationBasedOnDate(
                      application?.createdAt,
                      grossAnnualValidation
                    )
                      ? newGrossAnnualMaster
                      : grossAnnualMasters
                    ).map((grossIncome) => ({
                      key: grossIncome,
                      value: grossIncome,
                    }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.netWorth`}
                    label="Net Worth *"
                    placeholder="Enter Net Worth"
                  />
                  {values.applicants[index].netWorth &&
                    !isNaN(Number(values.applicants[index].netWorth)) && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(values.applicants[index].netWorth)}
                      </Typography>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Net worth as on *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'Enter Net worth as on'}
                    name={`applicants.${index}.netWorthDate`}
                    maxDate={!ICEF_I_Fund(Number(values?.schemeId)) ? maxNetworthDate() : undefined}
                    minDate={
                      ICEF_I_Fund(Number(values?.schemeId))
                        ? minNetworthDate(application?.createdAt || '')
                        : checkValidationBasedOnDate(application?.createdAt, netWorthValidationDate)
                        ? getLastFinancialYearEnd()
                        : undefined
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.politicallyExposedPersonStatus`}
                    label="Politically Exposed Person (PEP) Status"
                    items={PEPsMasters.map((pep) => ({ key: pep.key, value: pep.value }))}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.detailsOfFamilyCompany`}
                    label="Details of Investor Family/group company"
                    placeholder="Enter Details of Investor Family/group company"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.registeredAs`}
                    label={
                      isIndia_Assets_Excellence_Fund1(
                        application?.schemeId ? Number(application.schemeId) : null
                      )
                        ? 'Type of Entity *'
                        : ' Whether Registered as NBFC/Pension Fund/Insurance Company/Provident Fund/SEBI Registered Intermediary *'
                    }
                    items={Object.entries(whetherRegisterMaster)
                      .filter(([value]) =>
                        isIndia_Assets_Excellence_Fund1(
                          values?.schemeId ? Number(values.schemeId) : null
                        )
                          ? true
                          : !['banks', 'AIFs'].includes(value)
                      )
                      .map(([value, key]) => ({
                        key,
                        value,
                      }))}
                    onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                      setFieldValue(`applicants.${index}.registeredAs`, value);
                      setFieldValue(`applicants.${index}.registrationNumber`, '');
                    }}
                    applyLabelStyles={true}
                    reduceFontSize={true}
                  />
                </Grid>
                {!values.applicants[index].registeredAs ||
                  (whetherRegisterMaster[values.applicants[index].registeredAs || ''] !==
                    whetherRegisterMaster.none_of_above && (
                    <Grid item xs={12} sm={6}>
                      <MFTextField
                        name={`applicants.${index}.registrationNumber`}
                        label="Registration Number *"
                        placeholder="Enter Registration Number"
                      />
                    </Grid>
                  ))}
                {/* <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.ckycVerified`}
                    label="CKYC Verified"
                    placeholder="Enter CKYC Verified"
                    disabled={true}
                  />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.kraVerified`}
                    label="CVL KRA Verified"
                    placeholder="Enter CVL KRA Verified"
                    disabled={true}
                  />
                </Grid>

                <DematDetails values={values} index={index} disabled={false} />
              </React.Fragment>
            ))}
            <ProceedSaveLater
              showSaveAndProceed={checkPmsPoa(values.applicants)}
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
        </>
      )}
    </Formik>
  );
}
